import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1331 10.917C14.4996 10.917 14.7999 11.2165 14.8 11.583C14.8 11.9497 14.4997 12.25 14.1331 12.25H3.46704C3.10037 12.25 2.80005 11.9497 2.80005 11.583C2.80023 11.2165 3.10048 10.917 3.46704 10.917H14.1331ZM14.1331 7.58301C14.4997 7.58301 14.8 7.88333 14.8 8.25C14.8 8.61667 14.4997 8.91699 14.1331 8.91699H3.46704C3.10037 8.91699 2.80005 8.61667 2.80005 8.25C2.80005 7.88333 3.10037 7.58301 3.46704 7.58301H14.1331ZM14.1331 4.25C14.4997 4.25 14.8 4.55033 14.8 4.91699C14.7999 5.28351 14.4996 5.58301 14.1331 5.58301H3.46704C3.10048 5.58301 2.80023 5.28351 2.80005 4.91699C2.80005 4.55033 3.10037 4.25 3.46704 4.25H14.1331Z",
		fill: "currentColor"
	})
});
export default SvgHamburger;
